module.exports = __webpack_public_path__ + "static/media/teem-logo.7957dcc2.png";